import { IdentityHostname } from './identity';
import type { Environment } from './interface';

export const devel: Environment = {
  apiBusinessGqlUrl: 'https://devel-business-center.pipelinersales.com/api/business/graphql',
  apiCustomerGqlOrigin: `https://devel-customer-portal.${IdentityHostname}`,
  apiUserGqlUrl: `https://devel-api.${IdentityHostname}/api/user/graphql`,
  apiSchedulerGqlUrl: 'https://devel-api.pipelinersales.com/api/scheduler/public/graphql',
  apiOnlineFormGqlUrl: 'https://devel-api.pipelinersales.com/api/online-form/public/graphql',
  apiPublicGqlUrl: "https://devel-api.pipelinersales.com/api/public/graphql",
  businessCenterUrl: 'https://devel-business-center.pipelinersales.com',
  customerPortalUrl: 'https://devel-customer-portal.pipelinersales.com',
  partnerPortalUrl: 'https://devel-partner-portal.pipelinersales.com',
  crmUrl: `https://devel-crm.${IdentityHostname}`,
  schedulerUrl: `https://devel-scheduler.pipelinersales.com`,
  signUpUrl: 'https://staging-wordpress.pipelinersales.com/crm/free-trial/',
  ssoUrl: 'https://devel-accounts.pipelinersales.com',
  formsUrl: `https://devel-forms.pipelinersales.com`,
};
